module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "enterpriseWebsite"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "searchCondition"
  }, [_c('div', {
    staticClass: "searchLine"
  }, [_c('div', {
    staticClass: "searchUnit"
  }, [_c('label', [_vm._v("企业名称")]), _vm._v(" "), _c('el-select', {
    on: {
      "change": _vm.companyChange
    },
    model: {
      value: (_vm.companyVar),
      callback: function($$v) {
        _vm.companyVar = $$v
      },
      expression: "companyVar"
    }
  }, _vm._l((_vm.companyOpts), function(item) {
    return _c('el-option', {
      key: item.company,
      attrs: {
        "label": item.company,
        "value": item.company
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "searchUnit"
  }, [_c('label', [_vm._v("企业网站")]), _vm._v(" "), _c('el-select', {
    model: {
      value: (_vm.websiteVar),
      callback: function($$v) {
        _vm.websiteVar = $$v
      },
      expression: "websiteVar"
    }
  }, _vm._l((_vm.websiteOpts), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "searchUnit"
  }, [_c('label', [_vm._v("分析类别")]), _vm._v(" "), _c('el-select', {
    model: {
      value: (_vm.typeVar),
      callback: function($$v) {
        _vm.typeVar = $$v
      },
      expression: "typeVar"
    }
  }, _vm._l((_vm.typeOpts), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.label))])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "searchUnit"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": this.selected.startTime + ' - ' + this.selected.endTime,
      "picker-options": _vm.DatePickerOptions
    },
    on: {
      "change": _vm.dateRangeChange
    },
    model: {
      value: (_vm.datePickerModel),
      callback: function($$v) {
        _vm.datePickerModel = $$v
      },
      expression: "datePickerModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('button', {
    on: {
      "click": _vm.searchForCondition
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('a', {
    staticClass: "derive",
    on: {
      "click": function($event) {
        return _vm.export_analyze()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "enterpriseOrder-content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, _vm._l((_vm.title), function(item) {
    return _c('el-table-column', {
      key: item.label,
      attrs: {
        "prop": item.prop,
        "label": item.label,
        "show-overflow-tooltip": true
      }
    })
  }), 1), _vm._v(" "), _c('subpagination', {
    attrs: {
      "totalToPag": _vm.companyTotal
    },
    on: {
      "current-change": _vm.getCurrentListData
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enterpriseWebsite-top"
  }, [_c('div', {
    staticClass: "enterpriseWebsite-top-title"
  }, [_c('span', [_vm._v("企业网站")]), _vm._v(" "), _c('div', {
    staticClass: "attention"
  }, [_c('div', {
    staticClass: "attention-model"
  }, [_c('i'), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("来访次数\n                                "), _c('span', [_vm._v("1天内由该来源进入网站的访问次数")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("独立访客(UV)\n                                "), _c('span', [_vm._v("1天内由该来源进入网站的不重复用户数")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("IP\n                                "), _c('span', [_vm._v("1天内由该来源进入网站的不重复IP数")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("浏览页数(PV)\n                                "), _c('span', [_vm._v("由该来源进入网站的访客在网站上产生的总PV")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("人均浏览页数\n                                "), _c('span', [_vm._v("由该来源进入网站的每个独立访客平均产生的PV")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("平均访问深度\n                                "), _c('span', [_vm._v("由该来源进入网站的每次访问(会话)平均产生的PV")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("平均访问时长\n                                "), _c('span', [_vm._v("平均每次访问在网站上的停留时间")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("跳出率\n                                "), _c('span', [_vm._v("仅浏览了1个页面就离开网站的访问次数占比")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("输出PV\n                                "), _c('span', [_vm._v("由该页面点击到站内其他页面的PV")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("平均停留时长\n                                "), _c('span', [_vm._v("访客打开页面到离开该页面的平均时间差")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9a990ca","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseWebsite/enterpriseWebsite.vue
// module id = 597
// module chunks = 1